var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMapFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.50037C15.87 2.50037 19 5.63037 19 9.50037C19 13.2321 15.4633 18.2269 13.4177 20.8038C12.6811 21.7317 11.3189 21.7317 10.5823 20.8038C8.53669 18.2269 5 13.2321 5 9.50037C5 5.63037 8.13 2.50037 12 2.50037ZM12 7.00037C10.62 7.00037 9.5 8.12037 9.5 9.50037C9.5 10.8804 10.62 12.0004 12 12.0004C13.38 12.0004 14.5 10.8804 14.5 9.50037C14.5 8.12037 13.38 7.00037 12 7.00037Z",
    fill: "#362F73"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapFilled);
export default __webpack_public_path__ + "static/media/map-filled.5fc184163ae6b3c055c3db6c65e1c2a4.svg";
export { ForwardRef as ReactComponent };